import * as Actions from '../actions/actions-consts';
import { LoginLinkRequestedPayload } from '../actions/websiteCreation';
import { Action } from '../../definitions/types';

export default function loginLinkTimestamp(
  state: number = null,
  action: Action<any> // tslint:disable-line no-any
): number {
  switch (action.type) {
    case Actions.LOGIN_LINK_REQUESTED:
      return (action.payload as LoginLinkRequestedPayload).timestamp;
    default:
      return state;
  }
}
